import { render, staticRenderFns } from "./OnestopCompanyDetail.vue?vue&type=template&id=00c34d56"
import script from "./OnestopCompanyDetail.vue?vue&type=script&lang=js"
export * from "./OnestopCompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./OnestopCompanyDetail.vue?vue&type=style&index=0&id=00c34d56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports